import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { PhoneCallDTO } from "../../models/PhoneCall.model";
import { getPhoneCalls } from "../thunks/phoneCallThunks";

interface PhoneCallState {
  phoneCalls: PhoneCallDTO[];
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string;
}

const initialState: PhoneCallState = {
  phoneCalls: [],
  loading: false,
  error: null,
  success: false,
  message: "",
};

const phoneCallSlice = createSlice({
  name: "phoneCall",
  initialState,
  reducers: {
    clearPhoneCallMessages: (state) => {
      state.error = null;
      state.success = false;
      state.message = "";
    },
    clearPhoneCalls: (state) => {
      state.phoneCalls = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPhoneCalls.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPhoneCalls.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
        state.phoneCalls = action.payload.phoneCalls || [];
      })
      .addCase(getPhoneCalls.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.phoneCalls = [];
        state.error = action.payload || "Failed to get phone calls";
      });
  },
});

export const { clearPhoneCallMessages, clearPhoneCalls } =
  phoneCallSlice.actions;

export default phoneCallSlice.reducer;

export const selectPhoneCalls = (state: RootState) =>
  state.phoneCall.phoneCalls;
export const selectPhoneCallsLoading = (state: RootState) =>
  state.phoneCall.loading;
export const selectPhoneCallsError = (state: RootState) =>
  state.phoneCall.error;
export const selectPhoneCallsSuccess = (state: RootState) =>
  state.phoneCall.success;
export const selectPhoneCallsMessage = (state: RootState) =>
  state.phoneCall.message;
